import { MENTOR_PROTOCOL } from "@gigsync/protocol";
import { ulid } from "ulid";
import { everyDeviceSpeaks } from "../net/reach.js";
import { MentorError, MentorRefusal } from "./errors.js";
/** True when `user` has a phone signed in and every one of their phones understands the mentor envelopes. */
export const reachesMentor = (m, user) => everyDeviceSpeaks(m.relay, user, MENTOR_PROTOCOL);
/** Refuses a mentor envelope to someone whose phones cannot all read it. */
export async function mustReach(m, user) {
    if (!(await reachesMentor(m, user)))
        throw new MentorError(MentorRefusal.tooOld);
}
/** The server's mentor routes, or a refusal when this build has none. */
export function apiOf(m) {
    if (!m.api)
        throw new MentorError(MentorRefusal.noServer);
    return m.api;
}
/** A fresh channel: the `engagement` every envelope toward and on one mentor link carries. */
export const newChannel = (m) => `eng_${ulid(m.ctx.clock.now().getTime())}`;
//# sourceMappingURL=context.js.map